// ==========================================
// APP ROUTER - Allo Artisan
// ==========================================
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { PublicLayout } from "@/layouts/PublicLayout";
import { AdminLayout } from "@/layouts/AdminLayout";
import { HomePage } from "@/pages/HomePage";
import { AdminLoginPage } from "@/pages/admin/AdminLoginPage";
import { DashboardPage } from "@/pages/admin/DashboardPage";
import { HeroAdminPage } from "@/pages/admin/HeroAdminPage";
import { ContentAdminPage } from "@/pages/admin/ContentAdminPage";
import { ArtisansAdminPage } from "@/pages/admin/ArtisansAdminPage";
import { TestimonialsAdminPage } from "@/pages/admin/TestimonialsAdminPage";
import { FAQAdminPage } from "@/pages/admin/FAQAdminPage";
import { MessagesAdminPage } from "@/pages/admin/MessagesAdminPage";
import { MediaAdminPage } from "@/pages/admin/MediaAdminPage";
import { AdminsAdminPage } from "@/pages/admin/AdminsAdminPage";
import { SettingsAdminPage } from "@/pages/admin/SettingsAdminPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicLayout />}>
            <Route index element={<HomePage />} />
          </Route>

          {/* Admin Login */}
          <Route path="/admin/login" element={<AdminLoginPage />} />

          {/* Admin Dashboard */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="hero" element={<HeroAdminPage />} />
            <Route path="content" element={<ContentAdminPage />} />
            <Route path="artisans" element={<ArtisansAdminPage />} />
            <Route path="testimonials" element={<TestimonialsAdminPage />} />
            <Route path="faq" element={<FAQAdminPage />} />
            <Route path="messages" element={<MessagesAdminPage />} />
            {/* <Route path="media" element={<MediaAdminPage />} /> */}
            <Route path="admins" element={<AdminsAdminPage />} />
            <Route path="settings" element={<SettingsAdminPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: "#1C2340",
            color: "#fff",
            borderRadius: "12px",
          },
          success: {
            iconTheme: { primary: "#E8671A", secondary: "#fff" },
          },
          error: {
            iconTheme: { primary: "#EF4444", secondary: "#fff" },
          },
        }}
      />
    </QueryClientProvider>
  );
}
